import { ModuleLayout, NavigationItem } from '@/components/ModuleLayout'
import { LayoutDashboard, Users, Shield, Bot, Settings } from 'lucide-react'

const navigation: NavigationItem[] = [
  {
    name: 'Panel Principal',
    href: '/admin/dashboard',
    icon: LayoutDashboard,
  },
  {
    name: 'Usuarios',
    href: '/admin/users',
    icon: Users,
  },
  {
    name: 'Roles',
    href: '/admin/roles',
    icon: Shield,
  },
  {
    name: 'Inteligencia Artificial',
    href: '/admin/chatbot-settings',
    icon: Bot,
  },
  {
    name: 'Sistema',
    href: '/admin/system',
    icon: Settings,
  },
]

export function AdminModuleLayout({ children }: { children: React.ReactNode }) {
  return (
    <ModuleLayout
      moduleName="Administración"
      moduleIcon={Settings}
      moduleColor="from-gray-700 to-gray-800"
      navigation={navigation}
    >
      {children}
    </ModuleLayout>
  )
}
